import * as Yup from "yup";
import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  Alert,
  Snackbar,
  Radio,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Paper,
  Typography,
  Avatar,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../../components/Iconify";
import {
  FormProvider,
  RHFTextField,
  RHFCheckbox,
} from "../../../components/hook-form";
import { postDataApi } from "../../../utils/apis";
//redux
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../redux/features/authSlice";
import { areaOfActivity, EntityType } from "../../../common/enum";
import {
  activityRecieverOptions,
  activitySpecialRecieverOptions,
  profileOptions,
} from "../../../data";
import { activityOptions } from "../../../data";

// ----------------------------------------------------------------------

export default function ProfileOptionsForm({ t }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { auth } = useSelector((state) => state);
  const { entity } = auth.profile || {};

  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const LoginSchema = Yup.object().shape({
    entityType: Yup.string().required("Email é de preenchimento obrigatório"),
    areaOfCctivity: Yup.string().required("Password é de preenchimento obrigatório"),
    isGroupEntity: Yup.string().required("Password é de preenchimento obrigatório"),
    // .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, {message: "Password should be minimum 8 in length and at least one letter and number", excludeEmptyString: false}),
  });

  const defaultValues = {
    email: "",
    password: "",
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setError,
  } = methods;

  const onSubmit = async () => {
    const data = methods.getValues();
    dispatch(login({ data }))
      .unwrap()
      .then((successResult) => {
        navigate("/dashboard");
      })
      .catch((error) => {
        //console.log(error);
        switch (error.code) {
          case "ERR_BAD_REQUEST":
            setError("email", {
              type: "AuthFail",
              message: t("wrongPassOrEmailMsg"),
            });
            break;
        }
      });
  };

  const selectedProfileOptions = React.useMemo(() => {
    return profileOptions.options.filter(
      (item) => item.value === entity?.entityType
    );
  }, [entity]);

  const selectedAreaOfActivity = React.useMemo(() => {
    if (EntityType.specialDistributor === entity?.entityType) {
      return activitySpecialRecieverOptions.options.filter(
        (item) => item.value === entity?.areaOfActivity
      );
    } else {
      return activityOptions.options.filter(
        (item) => item.value === entity?.areaOfActivity
      );
    }
  }, [entity]);
  
  return (
    <Paper
    variant="outlined"
    sx={{
      display: "flex",
      flexDirection: "column",
      p: 1,
    }}
  >
    <Stack spacing={3}>
      <Typography variant={"h3"} style={{fontSize:"14px"}}>{t("profileQuestion")}</Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          width: "fit-content",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Avatar
          variant="square"
          src={selectedProfileOptions[0].img}
          alt={selectedProfileOptions[0].title}
          sx={{ width: 32, height: 32, objectFit: "contain" }}
        />
        <Typography variant="body2" ml={2} fontWeight={600}>
          {t(`${selectedProfileOptions[0].title}`)}
        </Typography>
      </Paper>
      <Typography variant={"h3"} style={{fontSize:"14px"}}>{t("activityQuestion")}</Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          width: "fit-content",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Avatar
          variant="square"
          src={selectedAreaOfActivity[0].img}
          alt={selectedAreaOfActivity[0].title}
          sx={{ width: 32, height: 32 }}
        />
        <Typography variant="body2" ml={2} fontWeight={600}>
          {t(
            `${
              entity?.EntityType === EntityType.distributor &&
              selectedAreaOfActivity[0].value === areaOfActivity.other
                ? "otherReceiver"
                : selectedAreaOfActivity[0].title
            }`
          )}
        </Typography>
      </Paper>
    </Stack>
    </Paper>
    // // <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)} disabled>
    //   <Stack spacing={3}>
    //     <FormLabel id="demo-radio-buttons-group-label">
    //     {t("profileQuestion")}
    //     </FormLabel>
    //     <RadioGroup
    //       aria-labelledby="demo-radio-buttons-group-label"
    //       defaultValue="female"
    //       name="radio-buttons-group"
    //     >
    //       <FormControlLabel
    //         checked={EntityType.donor === entity?.entityType}
    //         vale={EntityType.donor}
    //         control={<Radio />}
    //         label={t("donor")}
    //       />
    //       <FormControlLabel
    //         checked={EntityType.distributor === entity?.entityType}
    //         value={EntityType.distributor}
    //         control={<Radio />}
    //         label={t("distributor")}
    //       />
    //       <FormControlLabel
    //         checked={EntityType.donorDistributor === entity?.entityType}
    //         value={EntityType.donorDistributor}
    //         control={<Radio />}
    //         label={t("donorDistributor")}
    //       />
    //     </RadioGroup>
    //     <FormLabel id="demo-radio-buttons-group-label">
    //       {t("activityQuestion")}
    //     </FormLabel>

    //     <RadioGroup
    //       aria-labelledby="demo-radio-buttons-group-label"
    //       defaultValue="female"
    //       name="radio-buttons-group"
    //     >
    //       <FormControlLabel
    //         checked={areaOfActivity.feedBank === entity.areaOfActivity}
    //         value={areaOfActivity.feedBank}
    //         control={<Radio />}
    //         label={t("feedBank")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.hotel === entity.areaOfActivity}
    //         value={areaOfActivity.hotel}
    //         control={<Radio />}
    //         label={t("hotel")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.restaurants === entity.areaOfActivity}
    //         value={areaOfActivity.restaurants}
    //         control={<Radio />}
    //         label={t("restaurants")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.catering === entity.areaOfActivity}
    //         value={areaOfActivity.catering}
    //         control={<Radio />}
    //         label={t("catering")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.publicEntities === entity.areaOfActivity}
    //         value={areaOfActivity.publicEntities}
    //         control={<Radio />}
    //         label={t("publicEntities")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.industry === entity.areaOfActivity}
    //         value={areaOfActivity.industry}
    //         control={<Radio />}
    //         label={t("industry")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.ipss === entity.areaOfActivity}
    //         value={areaOfActivity.ipss}
    //         control={<Radio />}
    //         label={t("ipss")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.production === entity.areaOfActivity}
    //         value={areaOfActivity.production}
    //         control={<Radio />}
    //         label={t("production")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.retailer === entity.areaOfActivity}
    //         value={areaOfActivity.retailer}
    //         control={<Radio />}
    //         label={t("retailer")}
    //       />
    //       <FormControlLabel
    //         checked={areaOfActivity.other === entity.areaOfActivity}
    //         value={areaOfActivity.other}
    //         control={<Radio />}
    //         label={
    //           EntityType.distributor === entity?.entityType
    //             ? t("otherReceiver")
    //             : t("other")
    //         }
    //       />
    //     </RadioGroup>
    //   </Stack>
    // </FormProvider>
  );
}
